import {MetaReducer} from '@ngrx/store';
import {environment} from '../../../environments/environment';
import {withLastVisitedRoute} from '@adnova/jf-ng-components';


export const metaReducers: MetaReducer[] = !environment.production ? [] : [];
metaReducers.push(withLastVisitedRoute);
